import React from 'react';
import { Group } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

import type { ContestRestartCardActionButtonsProps } from './types';

function ContestInviteCardActionButtons({
  handleDismiss,
  handleRestart,
  isLoading,
}: ContestRestartCardActionButtonsProps) {
  const { t } = useTranslation('contest');
  return (
    <Group grow /* eslint-disable-line local-rules/use-theme-tokens */ spacing={8}>
      <Button
        variant="tertiary-fill"
        size="small"
        loading={isLoading}
        disabled={isLoading}
        onClick={handleDismiss}
      >
        <Text variant="label-small">{t('common.contestRestartCard.actionButtons.dismiss')}</Text>
      </Button>
      <Button variant="primary-fill" size="small" disabled={isLoading} onClick={handleRestart}>
        <Text variant="label-small">{t('common.contestRestartCard.actionButtons.restart')}</Text>
      </Button>
    </Group>
  );
}

export default ContestInviteCardActionButtons;
